@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.action-button {
  padding-right: 0;
  margin-left: 10px;
  text-align: right;
  padding-left: 10px;
  > button {
    background: @print-document--action-button--background-color;
    border-top: 1px solid @print-document--action-button--border-color;
    border-bottom: 1px solid @print-document--action-button--border-color;
  }
}

.dropdown-menu {
  max-height: 80%;
}
